import React from 'react';
import PropTypes from 'prop-types';
import List from './List/List';
import { pickProductColor, minMaxPrice } from '../utils/shopify';
const linkResolver = require('../../config/linkResolver');

const ListProducts = ({ input }) => {
  let products =
    input &&
    input.map(({ node }) => ({
      key: node.id.toString(),
      type: 'inline',
      dest: linkResolver('product', node.handle),
      theme_light: pickProductColor(node.productType).text,
      theme_dark: pickProductColor(node.productType).background,
      thumbnail: {
        url: node.images.edges[0].node.transformedSrc,
        alt:
          node.images.edges[0].node.altText ||
          node.title + ' ' + node.productType,
      },
      title: node.title,
      metaText: node.productType,
      topLeft: minMaxPrice(
        node.priceRange.minVariantPrice.amount,
        node.priceRange.maxVariantPrice.amount,
        node.priceRange.minVariantPrice.currencyCode || 'USD'
      ),
    }));

  return <List itemWidth={33} isFullWidth cards={products} />;
};

ListProducts.propTypes = {
  input: PropTypes.array.isRequired,
};

export default ListProducts;
